<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Tariff List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Instrument Name</label>
          <input [(ngModel)]="Filter_title" name="Filter_title" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Description</label>
          <input [(ngModel)]="Filter_dsc" name="Filter_dsc" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div>
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Tariff()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search Tariffs </button>
          <button *ngIf="!Procssing" routerLink="/TariffAdd" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <button *ngIf="!Procssing" (click)="exportexcel_Import()" type="button" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel (For Import) </button>
          <button *ngIf="!Procssing" (click)="openModal_Tariff(templateTariff)" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Upload Tariffs </button>

          <button *ngIf="!Procssing" routerLink="/TariffFloor" type="button" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa fa-file-excel-o"></i> Set Minimum Customer Letter Tariff </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />


        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <b>Instruments with Tariffs: {{DeviceHasTarrif}} items</b>
        </div>
        <div class="form-group col-md-6">
          <b>Minimum Customer Letter Tariff: {{TarrifFloor|number}} IRR</b>

        </div>
      </div>

      <br />
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Tariff ID</th>
              <th>Instrument Name</th>
              <th>Description</th>
              <th>Unit Amount (IRR)</th>
              <th>Score</th>
              <th>Expense</th>
              <th>Expiration Date</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Tariff
                            | paginate
                                    : {
                                        id: 'DataList_FeildTable',
                                        itemsPerPage: 50,
                                        currentPage: page,
                                        totalItems: (DataList_Tariff).length
                                      }
                            ">

              <tr>
                <td rowspan="2">{{DataList_Tariff.indexOf(item)+1}}</td>
                
                <td>{{item.id}}</td>
                <td>{{item.device_name}}</td>
                <td>{{item.dsc}}</td>
                <td>{{item.tariff|number}}</td>
                <td>{{item.tariff_expert|number}}</td>
                <td>{{item.tariff_hazineh|number}}</td>
                <td>{{item.expiredDate}}</td>
                <td>{{item.persianDate}}</td>
                <td>{{item.username}} </td>
                
                <td  rowspan="2">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" [routerLink]="['/TariffEdit',{id:item.id}]"><i class="fa fa-edit"></i>
                          Edit </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i
                            class="fa fa-remove"></i> Delete </a>
                      </div>
                    </div>

                    <div *ngIf="item.DeletingProccess">
                      <img src="assets/Loading.gif" style="width: 25px;" />
                    </div>
                  </div>
                </td>

              </tr>

              <tr>
                <th>T1</th>
                <td>{{item.t1}}</td>
                <th>T2</th>
                <td>{{item.t2}}</td>
                <th>T3</th>
                <td>{{item.t3}}</td>
                <th>T4</th>
                <td colspan="2">{{item.t4}}</td>
              </tr>

            </ng-container>


          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Tariff '{{Data_Seleted_Delete.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateTariff>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Upload Tariffs </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Tariff.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Select the Excel file </label>
        <input type="file" #file_excel>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
      (click)="upload_file_excel(file_excel.files)"> Upload File <i class="fa fa-upload"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Tariff.hide()">Close <i
        class="fa fa-remove"></i></button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Tariff ID</th>
      <th>ID Instrument</th>
      <th>Instrument Name</th>
      <th>Description</th>
      <th>Measurement Quantity</th>
      <th>Subquantity</th>
      <th>Unit Amount (IRR)</th>
      <th>Score</th>
      <th>Expense</th>
      <th>Date</th>
      <th>User</th>
      <th>T1</th>
      <th>T2</th>
      <th>T3</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Tariff">
      <td>{{DataList_Tariff.indexOf(item)+1}}</td>
      <td>{{item.id}}</td>
      <td>{{item.device_id}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.dsc}}</td>
      <td>{{item.quantity}}</td>
      <td>{{item.quantity_sub}}</td>
      <td>{{item.tariff|number}}</td>
      <td>{{item.tariff_expert|number}}</td>
      <td>{{item.tariff_hazineh|number}}</td>
      <td>{{item.persianDate}}</td>
      <td>{{item.username}} </td>
      <td>{{item.t1}}</td>
      <td>{{item.t2}}</td>
      <td>{{item.t3}}</td>
    </tr>
  </tbody>
</table>

<table id="excel-table-import" style="display: none;">
  <thead>
    <tr>
      <th>#</th>

      <th>ID Instrument</th>
      <th>Instrument Name</th>
      <th>Description</th>
      <th>Unit Amount (IRR)</th>
      <th>Score</th>
      <th>Expense</th>
      <th>Measurement Quantity</th>
      <th>Subquantity</th>
      <th>Expiration Date</th>
      <th>T1</th>
      <th>T2</th>
      <th>T3</th>
      <th>Tariff ID</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Tariff_Import">
      <td>{{DataList_Tariff_Import.indexOf(item)+1}}</td>
      <td>{{item.id}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.dsc}}</td>
      <td>{{item.tariff|number}}</td>
      <td>{{item.tariff_expert|number}}</td>
      <td>{{item.tariff_hazineh|number}}</td>
      <td>{{item.quantity}}</td>
      <td>{{item.quantity_sub}}</td>
      <td>{{item.expiredDate}}</td>
      <td>{{item.t1}}</td>
      <td>{{item.t2}}</td>
      <td>{{item.t3}}</td>
      <td>{{item.id2}}</td>
    </tr>
  </tbody>
</table>
